import React, {useEffect} from "react";
import {
    useToast,
} from "@chakra-ui/react";
import {logout, postData} from "../../../services/api";

function Logout() {

    const toast = useToast()

    useEffect(() => {
        const handleLogout = async () => {
            try {
                const success = await postData('/api/logout');
                if (success) {
                    logout();
                } else {
                    toast({
                        title: 'Logout nicht erfolgreich',
                        status: 'error',
                        isClosable: true,
                    })
                }
            } catch (error) {
                window.location.href = '#/auth/login'; // or display an error message
            }
        };

        handleLogout(); // Call logout when the component is rendered
    }, []);

    return (
        <></>
    );
}

export default Logout;
